
let skip = 0;
let infiniti = true;
let total = 0;

$(function () {
    if ($("#navbar-top").html().trim() === '') {
        $("#loginBlock").addClass('hide');
    };

    load_localities();
    load_areas();
    infiniti_scroll_postulant_list();
    filter_postulants();
    $("#search_input").on('keydown', function (e) {
        if (e.keyCode === 13) { // Enter
            load_localities();
            load_areas();
            filter_postulants();
        }
    });

    $("#areas_select").on('change', function () {
        filter_postulants();
        load_localities();
    });

    $("#locality_select").on('change', function () {
        filter_postulants();
        load_areas();
    });

});

function getScrollTop() {
    return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}

function getDocumentHeight() {
    let body = document.body;
    let html = document.documentElement;

    return Math.max(
            body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight
            );
}

function infiniti_scroll_postulant_list() {
    window.onscroll = onScroll;
}

async function onScroll (event) {
    let scrollTop = getScrollTop();
    let innerHeight = window.innerHeight;
    // let documentHeight = getDocumentHeight();
    let lastJobPosition = $('li.vacantes').last().position()
    if (!lastJobPosition ) {
        return;
    }

    if ((scrollTop + innerHeight >= lastJobPosition.top) && infiniti) {
        if ((skip + 10) < total) {
            console.log('scroll');
            skip += 10;
            infiniti = false;
            $('#loadmoreajaxloader').css('display', 'block');

            var final = {};

            final['skip'] = skip;
            final['searched'] = $('#search_input').val();
            final['area'] = $("#areas_select").val();
            final['locality'] = $('#locality_select').val();

            let idMicrosite = $('#id_microsite');
            if (idMicrosite.length > 0) {
                final['id_microsite'] = $('#id_microsite').val();
            }

            let url = document.URL.split('/');

            if (url[3] === 'referrals' && url[4] === 'jobs') {
                final['isFromReferrer'] = 'true';
                url = "/referrals/jobs/getVacancies";
            } else {
                final['isFromReferrer'] = 'false';
                url = "/jobs/filter_vacancy";
                var isMicrosite = $('#id_microsite').val();
                final['isMicrosite'] = isMicrosite;
            }

            try {
                let data = await $.ajax({
                    url: url,
                    type: 'POST',
                    data: final,
                    dataType: 'json'
                });

                console.log('html');
                $("#vacancies-list .vacancy").append(data.html);
                $('#loadmoreajaxloader').css('display', 'none');
                infiniti = true;

            } catch (err) {
                console.error(err);
            }
        } else {
            $('#loadmoreajaxloader').html('<center>No hay más postulantes.</center>');
            $('#loadmoreajaxloader').css('display', 'none');
        }
    }
    event.preventDefault();
}

async function filter_postulants() {
    $("#vacancies-list .vacancy").empty();
    $('#loadmoreajaxloader').css('display', 'block');
    let final = {};
    skip = 0;
    final['skip'] = skip;
    final['searched'] = $('#search_input').val();
    final['area'] = $("#areas_select").val();
    final['locality'] = $('#locality_select').val();

    let idMicrosite = $('#id_microsite');
    if (idMicrosite.length > 0) {
        final['id_microsite'] = $('#id_microsite').val();
    }

    let url = document.URL.split('/');

    if (url[3] === 'referrals' && url[4] === 'jobs') {
        final['isFromReferrer'] = 'true';
        url = "/referrals/jobs/getVacancies";
    } else {
        final['isFromReferrer'] = 'false';
        url = "/jobs/filter_vacancy";
        var isMicrosite = $('#id_microsite').val();
        final['isMicrosite'] = isMicrosite;
    }

    try {
        let data = await $.ajax({
            url: url,
            type: 'POST',
            data: final,
            dataType: 'json'
        });

        if (!data) {
            $("#vacancies-list .vacancy").append(`
                <li class="vacantes">
                    <div class="detailsContainer text-center">
                        <div class="col-md-12"><i class="hr-Search font-blue-dark"></i> No se han encontrado resultados.</div>
                    </div>
                </li>
            `);
            $('#loadmoreajaxloader').css('display', 'none');
            return;
        }

        total = data.count;
        $("#vacancies-list .vacancy").append(data.html);
        $('#loadmoreajaxloader').css('display', 'none');
        infiniti = true;
    } catch (err) {
        console.error(err);
    }
}

async function load_localities() {
    let url = document.URL.split('//')[1].split('.')[0];
    let area = $("#areas_select").val();
    let loc = $('#locality_select').val();
    let searched = $('#search_input').val();
    let array = document.URL.split('/');
    let multiple = '';
    if (array[4] === 'microsite') {
        multiple = array[5];
    }

    try {
        let data = await $.ajax({
            url: '/app/vacancy/get_acc_localities_ajax',
            type: 'POST',
            data: {
                account: url,
                areas: area,
                multiple: multiple,
                filter_text: searched
            },
            dataType: 'json'
        });

        if (!data) {
            return;
        }

        $('#locality_select').empty();
        $('#locality_select').append('<option value="" selected="selected">Ubicación</option>');
        $.each(data, function (index, value) {
            let locality = value.name.split(',')[0];

            let selectedFlag = loc === value.id ? 'selected="true"' : '';
            let component = `<option ${selectedFlag} value="${value.id}">${locality} (${value.cantidad})</option>`;
             $('#locality_select').append(component);

        });
    } catch (err) {
        console.error(err);
    }
}

async function load_areas() {
    let url = document.URL.split('//')[1].split('.')[0];
    let loc = $('#locality_select').val();
    let area = $("#areas_select").val();
    let searched = $('#search_input').val();
    let array = document.URL.split('/');
    let multiple = '';
    if (array[4] === 'microsite') {
        multiple = array[5];
    }

    try {
        let data = await $.ajax({
            url: '/app/vacancy/get_acc_areas_ajax',
            type: 'POST',
            data: {
                account: url,
                locality: loc,
                multiple: multiple,
                filter_text: searched
            },
            dataType: 'json'
        });

        if (!data) {
            return;
        }

        $('#areas_select').empty();
        $('#areas_select').append('<option value="" selected="selected">Area</option>');
        $.each(data, function (index, value) {
            let selectedFlag = parseInt(area) === value.id ? 'selected="true"' : '';
            let component = `<option ${selectedFlag} value="${value.id}">${value.name} (${value.cantidad})</option>`;
            $('#areas_select').append(component);
        });
    } catch (err) {
        console.error(new Error(err));
    }
}
